import { Suspense } from "react"
import { Route, Switch } from "react-router-dom"
import { AREAS_OFICIAIS, OFICIAIS_LOGIN_PATH } from "@/container/autenticacao/utils/areaOficial"
import { MainLoader } from "../components/MainLoader"
import { lazyNamed } from "../utility/lazy-named"
import { RedirectLoginLegado } from "./_autenticacao/redirect-login-legado"

const LOGIN_LEGADO_PATHS = Object.values(AREAS_OFICIAIS).flatMap(({ base }) => [
  base,
  `${base}/senha`,
  `${base}/recuperar-senha/:token`,
])

const LazyAutenticacaoRoutes = lazyNamed(() => import("./_autenticacao"), "AutenticacaoRoutes")
const LazyOficiaisRoutes = lazyNamed(() => import("./_oficiais"), "OficiaisRoutes")
const LazyMembrosRoutes = lazyNamed(() => import("./_membros"), "MembrosRoutes")
const LazyCadastroMembroOficialPage = lazyNamed(
  () => import("@/container/membro-exercito-sao-miguel/pages/cadastro-membro-oficial"),
  "CadastroMembroOficialPage"
)
const LazyPoliticasDePrivacidadePage = lazyNamed(
  () =>
    import(
      "@/container/membro-exercito-sao-miguel/pages/cadastro-membro-oficial/politicas-de-privacidade-page"
    ),
  "PoliticasDePrivacidadePage"
)
const LazyTermosDeUsoPage = lazyNamed(
  () =>
    import(
      "@/container/membro-exercito-sao-miguel/pages/cadastro-membro-oficial/termos-de-uso-page"
    ),
  "TermosDeUsoPage"
)

export const Routes = () => (
  <Switch>
    <Route path={OFICIAIS_LOGIN_PATH}>
      <Suspense fallback={<MainLoader />}>
        <LazyAutenticacaoRoutes />
      </Suspense>
    </Route>

    <Route exact path={LOGIN_LEGADO_PATHS}>
      <RedirectLoginLegado />
    </Route>

    <Route path={AREAS_OFICIAIS.generais.base}>
      <Suspense fallback={<MainLoader />}>
        <LazyOficiaisRoutes />
      </Suspense>
    </Route>

    <Route path={AREAS_OFICIAIS.membros.base}>
      <Suspense fallback={<MainLoader />}>
        <LazyMembrosRoutes />
      </Suspense>
    </Route>

    <Route exact path="/cadastro">
      <Suspense fallback={<MainLoader />}>
        <LazyCadastroMembroOficialPage />
      </Suspense>
    </Route>

    <Route exact path="/cadastro/politicas-de-privacidade">
      <Suspense fallback={<MainLoader />}>
        <LazyPoliticasDePrivacidadePage />
      </Suspense>
    </Route>

    <Route exact path="/cadastro/termos-de-uso">
      <Suspense fallback={<MainLoader />}>
        <LazyTermosDeUsoPage />
      </Suspense>
    </Route>
  </Switch>
)
